<div class="top-section">
    <div class="flex items-center">
        <app-svg name="hamburger" class="common-hamburger" (click)="ss.toggleSidebar()" role="button"
            [color]="ss.theme().color8" *ngIf="!cc.isNarrowScreen()"></app-svg>
        <h4 class="heading mb-0">{{ ss.t('common_attachment') }}</h4>
    </div>
    <div class="flex items-center gap-6">
        <app-notification [iconColor]="cc.isNarrowScreen() ? ss.theme().color12 : null"></app-notification>
        <app-svg *ngIf="hasAnyAttachments()" [name]="isFilter() ? 'filterOutline' : 'filter'" class="icon-mirror-rtl"
            [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8" class="filter-icon" role="button"
            (click)="toggleFilter()"></app-svg>
        <app-svg name="more" role="button" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"
            (click)="openKebabMenu()"></app-svg>
        <app-svg name="close" role="button" (click)="navigateToToday()"
            [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
    </div>
</div>

<div class="body-section attachment-sceen-body">
    <div class="filter-block" [ngClass]="{'h-auto filtered': isFilter() }" dragScroll>
        <app-filter-search [signal]="filters.query" [name]="'attachment'" class="me-2"></app-filter-search>

        <app-filter-hashtag [signal]="filters.tags" class="me-2"></app-filter-hashtag>

        <app-filter-feature [value]="filters.feature" class="me-2" [multiple]="true"
            [hiddenValues]="['focus','calendarIntegration']"></app-filter-feature>

        <app-filter-attachment [signal]="filters.attachments" [multiple]="true" class="me-2"></app-filter-attachment>

        <app-filter-role [value]="filters.role" class="me-2" [multiple]="true"></app-filter-role>

        <app-filter-date-range [startDate]="filters.dateFrom" [endDate]="filters.dateTo" [maxDate]="maxDate"
            class="me-2"></app-filter-date-range>

        <app-filter-status [value]="filters.status" [hiddenValues]="[]" class="me-2"
            [multiple]="true"></app-filter-status>

        <app-filter-mood [signal]="filters.moods" [multiple]="true" class="me-2"></app-filter-mood>

        <button class="btn btn-filter btn-clear" (click)="clearFilters()" *ngIf="isFiltered()">{{
            ss.t('common_clearAll') }}</button>
    </div>

    <!-- GROUP BY TASK NAME -->
    @if (groupBy() === 'entityTitle') {
    <div class="attachments-block ri-pb-4">
        @for (data of entitiesWithAttachments(); track data.id; let i = $index) {
        <div class="attachment-item entity-block">
            <div class="attachment-item-head flex justify-between items-center" (click)="openEntity(data.type, data.id)"
                role="button">
                <div class="flex items-center gap-4 entity-title-row">
                    <app-svg [name]="entityIconMap[data.type]" [color]="ss.theme().color35"
                        style="width: 14px; height: 14px; flex-shrink: 0;"></app-svg>
                    <p class="mb-0 text-14-400 color-35 entity-title-text">{{ data.title }}</p>
                </div>
                <span class="group-count" [class.visible]="scrolledEntities.has(data.id)">{{ data.attachments.length
                    }}</span>

            </div>
            <app-attachment-list class="attachment-list" [attachments]="data.attachments" [uid]="data.uid"
                [title]="data.title" [public]="data.isPublic ? true : false" [entityId]="data.id"
                [entityName]="data.type" (deleteEvent)="deleteAttachment($event, data)"
                (scrollStateChange)="onEntityScrollStateChange(data.id, $event)" [showDateOverlay]="true"
                [viewOnly]="data.memberRole === 'viewer'" [blockSize]="96"
                fromActionOrAttachment="Attachment"></app-attachment-list>
        </div>
        }
    </div>
    }

    <!-- GROUP BY MONTH -->
    @if (groupBy() === 'month') {
    <div class="attachments-block month-view ri-pb-4">
        @for (group of monthGroups(); track group.label) {
        <div class="month-group">
            <div class="month-group-header flex justify-between items-center">
                <p class="mb-0 text-14-400 color-35">{{ group.label }}</p>
                <span class="group-count" [class.visible]="scrolledEntities.has(group.label)">{{ group.items.length }}</span>
            </div>
            <div class="month-scroll-wrapper" [class.shadow-left]="monthScrollStates()[group.label]?.canLeft"
                [class.shadow-right]="monthScrollStates()[group.label]?.canRight ?? true">
                <div class="month-scroll-row" dragScroll #monthRow (scroll)="onMonthRowScroll(group.label, monthRow)">
                    @for (item of group.items; track item.attachment.id) {
                    <app-attachment-list class="month-grid-block" [attachments]="[item.attachment]"
                        [uid]="item.entity.uid" [title]="item.entity.title"
                        [public]="item.entity.isPublic ? true : false" [entityId]="item.entity.id"
                        [entityName]="item.entity.type" (deleteEvent)="deleteAttachment($event, item.entity)"
                        [showDateOverlay]="true" [isGridMode]="true"
                        fromActionOrAttachment="Attachment"></app-attachment-list>
                    }
                </div>
                @if (monthScrollStates()[group.label]?.canLeft) {
                <button class="month-arrow month-arrow-left" (click)="monthScrollLeft(monthRow)">
                    <app-svg name="chevronLeft"></app-svg>
                </button>
                }
                @if (monthScrollStates()[group.label]?.canRight ?? true) {
                <button class="month-arrow month-arrow-right" (click)="monthScrollRight(monthRow)">
                    <app-svg name="chevronRight"></app-svg>
                </button>
                }
            </div>
        </div>
        }
    </div>
    }

    <!-- GROUP BY NONE (flat grid) -->
    @if (groupBy() === 'none') {
    <div class="attachments-block grid-view flat-grid ri-pb-4">
        <div class="attachment-grid" #gridContainer>
            @for (item of flatAttachmentItems(); track item.attachment.id) {
            <app-attachment-list class="grid-block" [attachments]="[item.attachment]" [uid]="item.entity.uid"
                [title]="item.entity.title" [public]="item.entity.isPublic ? true : false" [entityId]="item.entity.id"
                [entityName]="item.entity.type" (deleteEvent)="deleteAttachment($event, item.entity)"
                [showDateOverlay]="true" [isGridMode]="true" fromActionOrAttachment="Attachment"></app-attachment-list>
            }
        </div>
    </div>
    }

    <app-no-result-block [message]="ss.t('common_noResultFound')" [imagePlaceholder]="'searchPlaceholder'"
        *ngIf="entitiesWithAttachments().length == 0 && isFiltered()" [showQuickGuide]="false"></app-no-result-block>
    <app-no-result-block [imagePlaceholder]="'attachmentPlaceholder'"
        [placeholder]="'common_attachmentEmptyScreenContent'"
        *ngIf="entitiesWithAttachments().length === 0 && !isFiltered()"></app-no-result-block>
</div>